import React from "react";
import PropTypes from "prop-types";

import NewsletterPromoWrapper from "cards/components/NewsletterPromoWrapper";
import NewsletterPromo from "cards/components/NewsletterPromo";

import image from "assets/img/AM-content.jpg";

export default function NewsletterPromoCard() {
  // eventually this information will be passed in from an external source
  // although these fields may not be named exactly correctly, they should be easy to swap out
  const data = {
    header: "Get Axios in your inbox",
    image,
    title: "Axios AM",
    content:
      "Start your day with precisely what you need to know from the world's most wired reporter.",
    link:
      "/newsletters/axios-am?source=axios&medium=referral&campaign=stream_cta_v1&content=axios_am",
    list: "newsletter_axiosam",
  };

  return (
    <NewsletterPromoWrapper header={data.header}>
      <NewsletterPromo
        image={data.image}
        title={data.title}
        content={data.content}
        link={data.link}
        list={data.list}
      />
    </NewsletterPromoWrapper>
  );
}
